<pxw-tag [type]="tagInfo.type" size="xs" class="shipping-status-tag">
  <pxw-icon icon="shipping" class="shipping-status-icon" />
  {{ tagInfo.label }}
</pxw-tag>
